import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

export const LinkIcon = ({ icon }) => (
  <div className="gray-circle d-flex align-items-center justify-content-center align-self-center rounded-circle me-1 bg-cool-gray-90 text-cool-gray-40">
    <span className={classnames('icon medium', icon)} aria-hidden />
  </div>
);

LinkIcon.displayName = 'LinkIcon';

LinkIcon.propTypes = {
  icon: PropTypes.string.isRequired,
};

LinkIcon.defaultProps = {};
